import { useNavigate } from 'react-router-dom';

export default function LogCard({
  action,
  type,
  title,
  subtitle,
  amount,
  date,
  reference,
  otherData,
}) {
  const navigate = useNavigate();

  const moneyFormat = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'PHP',
      minimumFractionDigits: 2,
    }).format(value);
  };

  return (
    <div className=' bg-white  '>
      <div className='flex items-start gap-2.5 border p-2.5 mt-2.5 rounded-md'>
        <div className='flex-1'>
          <div className='flex justify-between'>
            <div className='text-left'>
              <span className={`text-xs leading-4 text-[#65758B]`}>{type}</span>
              {action === 'MANUAL LOAD TO USER' &&
                otherData.userIdLoaded !== '' && (
                  <span className={`text-xs leading-4 text-[#65758B]`}>
                    {' '}
                    <a
                      href={`/user-games/${otherData.userIdLoaded}`}
                      className='text-[#007BFF]'
                    >
                      {otherData.userNameLoaded
                        ? otherData.userNameLoaded
                        : `# ${otherData.userIdLoaded}`}
                    </a>
                  </span>
                )}
              <h3 className='font-bold text-sm'>{title}</h3>
            </div>

            <div className='text-right'>
              <p className='text-[10px] text-[#65758B]'>{date}</p>
              <h3 className={`font-bold text-base text-${amount.color}`}>
                {amount.price}
              </h3>
              <span className={`text-[10px] text-[#65758B]`}>
                {moneyFormat(reference)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
